<template>
  <div class="common-tootip">
    <Tooltip
      ref="tlp"
      :content="text"
      :disabled="!tooltipFlag"
      :placement="placement"
      transfer
      :max-width="300"
    >
      <p @mouseenter="visibilityChange($event)" @click="clickText" class="over-flow">
        <i
          v-if="iconName"
          :class="`icon tsit ${iconName} mr-6 ml-6 ${
            status ? 'fontblue' : 'fonttwodark'
          }`"
        ></i>
        <span class="fontcursor text">{{ text }}</span>
      </p>
    </Tooltip>
  </div>
</template>

<script>
export default {
  name: "tooltipWrap",
  props: {
    text: { type: String, default: "" }, // 字符内容
    placement: { type: String, default: "top" },
    className: { type: String, default: "text" }, // class
    iconName: String,
    status: Number
  },
  data() {
    return {
      disabledTip: false,
      tooltipFlag: false
    };
  },
  methods: {
    clickText() {
      this.$emit("clickText");
    },
    // tooltip的可控
    visibilityChange(event) {
      const ev = event.target;
      const ev_weight = ev.scrollWidth; // 文本的实际宽度
      const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      console.log(event, "event--");
      if (ev_weight > content_weight) {
        // 文本宽度 > 实际内容宽度  =》内容溢出
        this.tooltipFlag = true;
      } else {
        // 否则为不溢出
        this.tooltipFlag = false;
      }
    }
  }
};
</script>

<style  lang="scss">
.common-tootip {
  height: 22px; // 必须要有高度设置，因为tooltip的显示条件是通过高度来判断的
  .ivu-tooltip {
    width: 100%;
  }
  .over-flow {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all; //英文数字折行
  }
  .icon-style {
    color: #85878b;
    position: relative;
    top: -2px;
    vertical-align: text-top;
  }
}
</style>

